import ads_video_bg from '../../../../img/create_ads/ads_video_bg.svg'

import { Pages } from '../../../../utils/Utils'
function AdsVkVideo(props) {
    const isShow = props.isShow
    if (!isShow) {
        return null
    }
    return (
        <a target='_blank' rel="noreferrer" href={Pages.ads_vk_video}>
            <div className='experts_item_3_ads hover ads_vk_video'>
                <img alt='' className='' src={ads_video_bg} />
                <div style={{ position: 'absolute', transform: 'translate(-50%, -50%)', textAlign : 'center' }} className='full_center ads_vk_video_width'>
                    <div style={{justifyContent : 'center'}} className='flex'>
                        <div style={{marginRight : '8px'}} className='ads_vk_video_tag'>Рост дохода</div>
                        <div className='ads_vk_video_tag'>Онлайн</div>
                    </div>
                    <div className='ads_vk_video_text'>Как найти учеников репетитору?<br/>Рассказали за 3 минуты в видео</div>
                </div>
            </div>
        </a>
    )
}
export default AdsVkVideo;